import React from 'react';
import { Divider, Drawer, useTheme } from '@mui/material';
import { AIStore } from 'services/store/ai';
import ArticlePanel from './ArticlePanel';
import ArticleHeader from './ArticleHeader';

type ArticlePropsType = {
  data: AIStore['infoGuide'];
  value: number | null;
  open: boolean;
  handleClose: () => void;
  handleBack: () => void;
};

const DRAWER_TRANSITION_DURATION = 500;

const MobileInfoArticle = ({
  data,
  value,
  open,
  handleClose,
  handleBack,
}: ArticlePropsType) => {
  const theme = useTheme();

  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={handleBack}
      transitionDuration={DRAWER_TRANSITION_DURATION}
      sx={{
        position: 'relative',
        zIndex: theme.zIndex.modal + 2,
        '& .MuiDrawer-paper': {
          width: '100%',
          height: '100%',
          boxSizing: 'border-box',
          bgcolor: theme.palette.grey[50],
          color: theme.palette.grey[900],
        },
      }}
    >
      <ArticleHeader
        open={open}
        handleBack={handleBack}
        handleClose={handleClose}
      />
      <Divider sx={{ borderColor: theme.palette.grey[200] }} />
      {data?.map((article) => (
        <ArticlePanel key={article.title} article={article} value={value} />
      ))}
    </Drawer>
  );
};
export default MobileInfoArticle;
